/**
 * @fileoverview Input/output schemas for chapter-restructure-v1.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { ChapterIdeaSchema } from '@/domains/chapter-workspace/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.seriesContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characterRoles.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterMetadata.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  chapters: z.array(ChapterIdeaSchema).describe('The restructured chapter outlines. May be fewer, equal, or more than the input chapters.'),
  explanation: z.string().describe('A brief explanation of the restructuring decisions: what was split, merged, or reorganised, and why.'),
});

export type Output = z.infer<typeof OutputSchema>;
